<figure class="blog-block-image">
  <img
    [src]="block.url"
    [alt]="alt"
    loading="lazy"
    [attr.width]="block.width || null"
    [attr.height]="block.height || null"
    referrerpolicy="no-referrer"
    />
  @if (block.caption) {
    <figcaption class="blog-block-image__caption">
      {{ block.caption }}
    </figcaption>
  }
</figure>
